<template>
  <v-card style="background-color:rgba(0,0,0,0)!important" flat>
    <v-card-text class="pa-0" style="position: relative">
      <v-chart :option="chartOptions" ref="chart" :style="styleObject" autoresize/>
    </v-card-text>
  </v-card>
</template>

<script>
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { GaugeChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent
} from 'echarts/components'
import VChart, { THEME_KEY } from 'vue-echarts'

use([
  CanvasRenderer,
  GaugeChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent
])

export default {
  name: 'GaugeChart',
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: 'light'
  },
  data() {
    return {
    }
  },
  mounted() {
    this.changeChartOptions()
  },
  props: {
    flag: {
      type: Number,
      default: 0
    },
    props: {
      type: Number,
      default: 0
    },
    title: String,
    height: {
      type: Number,
      default: 120
    },
    color: String,
    unit: {
      type: String,
      default: 'unit'
    },
    min: {
      type: [String, Number],
      default: 0
    },
    max: {
      type: [String, Number],
      default: 100
    },
    value: {
      type: [String, Number],
      default: 0
    }
  },
  computed: {
    styleObject() {
      if (this.height) {
        return { height: this.height + 'px' }
      } else {
        return {}
      }
    },
    chartOptions() {
      const chartUnit = this.unit
      return {
        title: {
          text: this.title,
          left: 'center',
          top: 2,
          textStyle: {
            fontSize: 14,
            color: '#B5BDC7'
          }
        },
        series: [
          {
            radius: '65%',
            center: ['50%', '60%'],
            type: 'gauge',
            startAngle: 270,
            endAngle: -90,
            pointer: {
              show: false
            },
            axisLine: {
              lineStyle: {
                width: '100%',
                color: [
                  [1, '#393947']
                ]
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            title: {
              show: false
            }
          },
          {
            radius: '80%',
            center: ['50%', '60%'],
            type: 'gauge',
            startAngle: 270,
            endAngle: -90,
            min: this.min,
            max: this.max,
            itemStyle: {
              color: this.color
            },
            progress: {
              show: true,
              width: 5
            },
            pointer: {
              show: false
            },
            axisLine: {
              lineStyle: {
                width: 5,
                color: [
                  [1, '#393947']
                ]
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            title: {
              show: false
            },
            detail: {
              valueAnimation: true,
              width: '60%',
              lineHeight: 20,
              height: '15%',
              offsetCenter: [0, '-15%'],
              formatter: function (value) {
                // return '{value|' + value.toFixed(1).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',') + '}\n{unit|' + chartUnit + '}'
                return '{value|' + value.toFixed(1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '}\n{unit|' + chartUnit + '}'
                // return '{value|' + value.toFixed(1).toString() + '}\n{unit|' + chartUnit + '}'
              },
              rich: {
                value: {
                  fontSize: 18,
                  color: '#ffffff'
                },
                unit: {
                  fontSize: 12,
                  color: '#B5BDC7'
                }
              }
            },
            data: [
              {
                value: 0
              }
            ]
          }
        ]
      }
    }
  },
  watch: {
    flag() {
      this.changeChartOptions()
    }
  },
  methods: {
    changeChartOptions() {
      this.$refs.chart.setOption({
        series: [
          {},
          {
            data: [
              {
                value: this.min
              }
            ]
          }
        ]
      })
      const ls = this
      setTimeout(function() {
        ls.$refs.chart.setOption({
          series: [
            {},
            {
              data: [
                {
                  value: ls.value
                }
              ]
            }
          ]
        })
      }, 500)
    }
  },
  beforeDestroy() {
    // 종료 전에 e차트가 사용한 리소스를 해제해야 하는 작업
    this.$refs.chart.clear()
    this.$refs.chart.dispose()
  }
}
</script>

<style scoped>
.chart {
  height: 150px;
}
</style>
